import { FC, useState } from 'react';

import { Attachment } from 'utils/types';
import { SIZE } from 'utils/constants';
import { inflect } from 'inflection';

import AttachedListItem from './AttachedListItem';
import Preview from './Preview';

interface PROPS {
  attachments: Attachment[];
  showRemove?: boolean;
  onDownload: (uri: string, name: string) => void;
  onClickShowAllAttachments: () => void;
  onRemove?: (attachmentId: string) => void;
  hideNumberOfFilesUploaded?: boolean;
}

const AttachedItemsList: FC<PROPS> = ({
  attachments,
  showRemove,
  hideNumberOfFilesUploaded,
  onDownload,
  onClickShowAllAttachments,
  onRemove,
}) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [fileToPreview, setFileToPreview] = useState<number>(0);

  const showPreview = (index: number) => {
    setOpenPreview(true);
    setFileToPreview(index);
  };
  const closePreview = () => setOpenPreview(false);

  if (!attachments?.length) return null;
  const attachmentsCount = attachments.length;
  return (
    <>
      <Preview
        open={openPreview}
        closeModal={closePreview}
        initialSlide={fileToPreview}
        files={attachments}
      />

      <div className="space-y-[6px] text-sm">
        {!hideNumberOfFilesUploaded && (
          <div>
            {attachmentsCount} {inflect('file', attachmentsCount)} uploaded
          </div>
        )}
        <div className="flex gap-x-[6px] overflow-x-auto pb-2">
          {[...attachments].slice(0, 3).map((attachment, index) => (
            <AttachedListItem
              showRemove={showRemove}
              onRemove={onRemove}
              showPreview={() => showPreview(index)}
              key={attachment._id}
              file={attachment}
              size={SIZE.Medium}
              onDownload={() =>
                onDownload(attachment.fileUrl, attachment.fileName)
              }
            />
          ))}
          {attachmentsCount > 3 ? (
            <button
              onClick={onClickShowAllAttachments}
              className="font-semibold text-lg"
            >
              +{attachmentsCount - 3}
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default AttachedItemsList;
